import { render } from "./BundleProducts.vue?vue&type=template&id=4a90d171&scoped=true"
import script from "./BundleProducts.vue?vue&type=script&lang=js"
export * from "./BundleProducts.vue?vue&type=script&lang=js"

import "./BundleProducts.vue?vue&type=style&index=0&id=4a90d171&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a90d171"]])

export default __exports__